import { z } from "zod";

/**
 * EK HAK SATIN ALMA VE YAŞAM DÖNGÜSÜ (CLOS-201 `[175]`).
 */

export const addOnCatalogEntrySchema = z.object({
  code: z.string(),
  entitlementKey: z.string(),
  name: z.string(),
  description: z.string(),
  billingMode: z.enum(["one_time", "recurring"]),
  unitQuantity: z.number().int(),
  /** Onaysızken `unitPriceMinorUnits` `null` — KARAR 05 ile aynı fail-closed davranış. */
  priceApproved: z.boolean(),
  unitPriceMinorUnits: z.number().int().nullable(),
  currency: z.string(),
});
export type AddOnCatalogEntry = z.infer<typeof addOnCatalogEntrySchema>;

export const addOnPurchaseSchema = z.object({
  id: z.uuid(),
  addOnCode: z.string(),
  entitlementKey: z.string(),
  quantity: z.number().int(),
  billingMode: z.enum(["one_time", "recurring"]),
  status: z.enum([
    "pending_payment",
    "active",
    "canceled",
    "expired",
    "refunded",
    "chargeback",
    "payment_failed",
  ]),
  periodStart: z.string().nullable(),
  periodEnd: z.string().nullable(),
  autoRenew: z.boolean(),
  createdAt: z.string(),
});
export type AddOnPurchase = z.infer<typeof addOnPurchaseSchema>;

/**
 * ⚠ `purchaseKey` çağıranın ürettiği MANTIKSAL anahtar (`lib/aiCredits.ts`'teki
 * `logicalKey` deseniyle aynı): ağ hatasında tekrar denenen aynı istek AYNI satın almayı
 * bulur, ikinci bir ödeme/entitlement üretmez.
 */
export const createAddOnPurchaseSchema = z.strictObject({
  addOnCode: z.string().trim().min(1, "Ek hak kodu zorunludur"),
  quantity: z.number().int().min(1, "Miktar en az 1 olmalıdır").max(1000),
  paymentMethodId: z.uuid("Geçerli bir ödeme yöntemi seçiniz"),
  purchaseKey: z.string().trim().min(8, "Geçerli bir işlem anahtarı zorunludur").max(200),
});
export type CreateAddOnPurchaseInput = z.infer<typeof createAddOnPurchaseSchema>;
